export const DEFAULT_EMAIL_DOMAINS = ["coulomb.ai"];

/**
 * Recipient domains the email composer accepts, resolved from org config.
 *
 * The canonical source is orgMeta.metaInfo.globalConfig["email.domains"] - the same
 * key the backend validates against (app/services/alert.py, alertsV2AnalyticsService.py):
 *
 *   "globalConfig": {
 *     ...
 *     "email.domains": ["coulomb.ai", "jbmgroup.com"]
 *   }
 *
 * The backend copies globalConfig onto EVERY page's metaInfo (app/services/user.py,
 * generatePageMetaInfoForUser), so any page that already fetches its pageMeta has the
 * list in hand - adding a domain for a new org is a DB-only change, no code edit.
 *
 * Domains are stored WITHOUT the leading '@', matching the backend's validateEmail
 * (app/util/helpers.py).
 *
 * metaInfo.availableEmailDomains is the older per-page key that the base pageMeta rows
 * and some org meta still carry; it is read only as a fallback, for an org whose
 * globalConfig has not been given "email.domains" yet.
 *
 * @param {object} metaInfo - the `metaInfo` object from a pageMeta response
 * @returns {string[]} non-empty domain list
 */
export const getAvailableEmailDomains = (metaInfo) => {
    const candidates = [
        metaInfo?.globalConfig?.["email.domains"],
        metaInfo?.availableEmailDomains,
    ];

    const configured = candidates.find((list) => Array.isArray(list) && list.length > 0);
    // Last resort rather than [] - an empty list makes the composer reject every
    // address while showing "Invalid domain. Valid domains are:" with nothing after it.
    return configured || DEFAULT_EMAIL_DOMAINS;
};
